interface Config {
  API_BASE_URL: string;
  API_PREFIX: string;
}

const CONFIG: Config = {
  // 开发环境使用 Vite 代理，生产环境使用实际 API 地址
  API_BASE_URL: import.meta.env.VITE_API_BASE_URL || 'https://www.younggo.click',
  API_PREFIX: '/api'
};

export default CONFIG;